{
  "version": 1,
  "asset_id": "5f42e3f9-38ec-4690-9320-40dfc60db37a",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/5f42e3f9-38ec-4690-9320-40dfc60db37a/sleeve-endoscopy-check-es-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/5f42e3f9-38ec-4690-9320-40dfc60db37a/sleeve-endoscopy-check-es-1200.webp",
  "original_filename": "sleeve-endoscopy-check-es-1200.webp",
  "size": 74442,
  "content_type": "image/webp",
  "created_at": "2026-10-05T00:22:01Z"
}
